export const isCloud = () => window.location.hostname.split('.').slice(-2).join('.') === 'testkontur.ru';
